export const IMAGES = {
  portrait: "https://customer-assets-jai6qajn.emergentagent.net/job_rail-leadership/artifacts/uaedls5q_ChatGPT%20Image%20Jul%2021%2C%202026%20at%2002_19_36%20AM.png",
  jetExterior: "https://static.prod-images.emergentagent.com/jobs/62e04f2a-beca-4cf3-b671-206f66856efd/images/7d88801453718cc710a3ee86f099e3997c3ba7919fbf72ab06a8718c2c9289f4.jpeg",
  cabinService: "https://static.prod-images.emergentagent.com/jobs/62e04f2a-beca-4cf3-b671-206f66856efd/images/205cbe31951ed4e780176d69855c45bce926a7c995316d1ad35475983b23e73b.jpeg",
  crewTraining: "https://static.prod-images.emergentagent.com/jobs/62e04f2a-beca-4cf3-b671-206f66856efd/images/716001d0e8c8b3703fd0a10c0d0b066f89ea5af6a2ff29b7d284a9ae0affaa3f.jpeg",
};

export const HERO = {
  overline: "Private Service Professional",
  name: "Melanie Ann Collins",
  lines: [
    { text: "I pride myself on the details", italic: false },
    { text: "no one ever has to notice.", italic: true },
  ],
  sub: "30 years in private service to principals and their families on the ground and in the sky.",
};

export const SCOPE = {
  overline: "Scope of Service",
  title: "What I take care of.",
  items: [
    {
      area: "Principal Support",
      body: "Complex and fluid calendar management, high volume request triage, correspondence and follow up, contact and relationship management, introductions, confidential document handling, personal procurement, gift and event logistics.",
    },
    {
      area: "Household & Estate",
      body: "Formal and informal service, wine and beverage programs, menu planning to principal preference and dietary requirement, vendor and contractor coordination, staff recruitment and training, provisioning, inventory, standards enforcement.",
    },
    {
      area: "Travel & Private Aviation",
      body: "Domestic and international itineraries across many legs, private aviation coordination, advance work, customs and immigration documentation, ground transportation and security liaison, hotel and residence preparation, charter coordination across private aircraft and yacht.",
    },
    {
      area: "Safety, Risk & Discretion",
      body: "Licensed protective training, threat awareness in transit and in residence, access control, emergency and medical response, confidentiality at NDA standard, sensitive financial and communications matters.",
    },
  ],
};

export const EXPERIENCE = {
  overline: "Experience",
  title: "Thirty years in private service.",
  roles: [
    {
      role: "Private Service Contractor",
      org: "Executive, entertainment, and diplomatic principals",
      dates: "2009 to 2026",
      body: "Five years exclusive to a nationally recognized media and entertainment executive, his family, and senior staff, on and off the aircraft. Managed itineraries across private aviation, ground, and yacht, with advance work, customs and immigration documentation, security liaison, and catering to principal preference and dietary requirement.",
    },
    {
      role: "Private Cabin Attendant",
      org: "American Express Financial Services, flight department, Gulfstream",
      dates: "2002 to 2009",
      body: "Seven years of continuous private service to the chairman and chief executive of a Fortune 100 corporation, his family, and executive guests. Designed and delivered the contract flight attendant training program within Cabin Standards and Services, recruiting, training, and leading crew to a written standard.",
    },
    {
      role: "Cabin Attendant",
      org: "Continental Airlines, domestic and international",
      dates: "1997 to 2002",
      body: "Career foundation in inflight safety and emergency and medical response.",
    },
  ],
  community: {
    name: "LYNC Community Organization",
    place: "Newburgh, New York",
    dates: "2018 to present",
    body: "Pursued a personal dream to start a nonprofit and build a school for underserved youth who learn differently. Acquired a federal grant of $1.3 million and initiated the YouthBuild school inside the Highpoint campus. Recognized with a New York State Senate Commendation Award.",
  },
};

export const CREDENTIALS = {
  overline: "Credentials",
  title: "Safety, formalized.",
  intro: "Licensed and trained for the proximity this work involves.",
  items: [
    { before: "New York State Licensed Security Guard, active registration with the NYS Division of Licensing Services." },
    { before: "Executive Protection Training, ", linkLabel: "Damon Finch Power Sessions", linkUrl: "https://damonfinch.com", after: ", Newburgh, New York." },
    { before: "Firearms Safety Training, ", linkLabel: "Damon Finch Power Sessions", linkUrl: "https://damonfinch.com", after: ", Newburgh, New York." },
    { before: "CPR, First Aid, and First Responder Medical, current." },
    { before: "", linkLabel: "FlightSafety International", linkUrl: "https://www.flightsafety.com", after: " trained." },
    { before: "ServSafe Food and Beverage Certified." },
    { before: "Valid United States passport. New York State driver's license, clean record. State and federal background checks completed." },
  ],
};

export const PRACTICAL = {
  technology: {
    label: "Technology",
    body: "Microsoft 365 and Google Workspace for calendar, correspondence, and document management. Daily use of AI tools including Claude, ChatGPT, Gemini, and Perplexity for research, drafting, itinerary building, and vendor comparison.",
  },
  availability: {
    label: "Availability",
    body: "Open to the schedule, travel, and location the right position requires. Available for an immediate start. References on request.",
  },
};

export const CONTACT = {
  overline: "Let's Talk",
  title: "If this resonates, I'd welcome the conversation.",
  email: "collinsmelanie845@gmail.com",
  phone: "845.598.6142",
  location: "Newburgh, New York",
};

export const FOOTER = { line: "Private Service Professional · New York · 2026" };
